import { BuyerCakeSchedule } from "../../../types";

export const BuyerCakeScheduleAction = {
  FETCH_BUYERCAKESCHEDULE: 'FETCH_BUYERCAKESCHEDULE',
  SHOW_BUYERCAKESCHEDULE: 'SHOW_BUYERCAKESCHEDULE',
  HIDE_BUYERCAKESCHEDULE: 'HIDE_BUYERCAKESCHEDULE',
  UPDATE_BUYERCAKESCHEDULE_ITEM: 'UPDATE_BUYERCAKESCHEDULE_ITEM',
  SAVE_BUYERCAKESCHEDULE: 'SAVE_BUYERCAKESCHEDULE',
  DEFAULT_BUYERCAKESCHEDULE: 'DEFAULT_BUYERCAKESCHEDULE',
  UPDATE_BUYERCAKESCHEDULE_LIST: 'UPDATE_BUYERCAKESCHEDULE_LIST',
  DELETE_BUYERCAKESCHEDULE: 'DELETE_BUYERCAKESCHEDULE',
};

export const BuyerCakeScheduleModalAction = {
  CREATE: 'MODAL_CREATE',
  EDIT: 'MODAL_EDIT',
  DELETE: 'MODAL_DELETE',
};

export const BuyerCakeScheduleURL = {
  REVIEW: 'api/BuyerCakeSchedule/Get',
  // CREATE: 'api/BuyerGroup/Create',
  UPDATE: 'api/BuyerCakeSchedule/Merge',
  // DELETE: 'api/BuyerGroup/Delete',
  // CHECK_DEFAULT: 'api/BuyerGroup/GetDefault',
  // COUNT: 'api/BuyerGroup/getCount',
};

export const EmptyBuyerCakeSchedule: BuyerCakeSchedule = {
  BuyerCakeScheduleEligibleCriteriaId: 0,
  CreatedDate: '',
  ModifiedDate: '',
  EligibleCriteria: '',
  IsActive: false,
  CriteriaDescription: '',
};